export default "__VITE_ASSET__5608c504__"